import { cloneElement } from 'react';
import classNames from 'classnames/bind';

import { H1 } from 'components/heading/Heading';
import { PictureProps } from 'components/picture/Picture';
import { VideoProps } from 'components/video/Video';

import { MediaPosition } from 'types/ui';

import s from './PowerStationHero.module.scss';

const c = classNames.bind(s);

type Props = {
  title?: string;
  video?: React.ReactElement<VideoProps>;
  image?: React.ReactElement<PictureProps>;
  children?: React.ReactNode;
  mediaOnly?: boolean; // dont show title
  mediaPosition?: MediaPosition;
};

export const PowerStationHero = ({
  title,
  image,
  video,
  children,
  mediaPosition,
  mediaOnly = true,
}: Props) => {
  return (
    <div className={c(s.powerStationHero, { mediaOnly })}>
      <div className={s.powerStationHero__content}>
        {title && <H1>{title}</H1>}
        {children && <div className={s.powerStationHero__text}>{children}</div>}
      </div>

      {video
        ? cloneElement(video, {
            className: s.powerStationHero__media,
            autoplay: false,
            loop: true,
            addLayout: false,
            videoPosition: mediaPosition,
          })
        : image &&
          cloneElement(image, {
            className: s.powerStationHero__media,
            draggable: false,
            lazy: false,
            imagePosition: mediaPosition,
          })}
    </div>
  );
};
